import MaterialTypeEnum from "../../enums/MaterialTypeEnum";

export default class Material
{
    id: number;
    materialType: MaterialTypeEnum;

    constructor(materialType: MaterialTypeEnum, materialId: number) {
            this.materialType = materialType;
            this.id = materialId;
        }
}

